export default "__VITE_ASSET___4NYoxaH__"